module.exports = __webpack_public_path__ + "img/Icon ionic-ios-add-circle.0dcbc66c.svg";